import { createCustomEnum } from "./customEnum";

const TerminalInstallTypes = createCustomEnum({
	Internal: {
		value: 0,
		name: "Internal",
		displayName: "Internal",
	},
	AuroraInstall: {
		value: 1,
		name: "AuroraInstall",
		displayName: "Aurora Install",
	},
	AgentInstall: {
		value: 2,
		name: "AgentInstall",
		displayName: "Agent Install",
	},
});

export default TerminalInstallTypes;
